// helper function is responsible to conver 6digit hex color to 8digit hex code by default html input type color doesn't support so it's hack to convertion.

export function convertTo8DigitHex(color6Digit, alpha = '80') {
  if (color6Digit[0] !== '#' || color6Digit.length !== 7) {
    return color6Digit;
  }

  if (typeof alpha === 'number') {
    alpha = alpha.toString(16).padStart(2, '0').toUpperCase();
  }

  if (typeof alpha === 'string' && (alpha.length !== 2 || !/^[0-9A-F]{2}$/i.test(alpha))) {
    throw new Error('Invalid alpha value');
  }

  const color8Digit = `${alpha}${color6Digit.slice(1)}`;
  return color8Digit;
}

export function convertTo6DigitHex(color8Digit) {
  if (color8Digit.length === 6) {
    return `#${color8Digit}`;
  }
  const color6Digit = `#${color8Digit.slice(2)}`;
  return color6Digit;
}
